export class Logger {
	prefix: string;
	colors: Colors;
	constructor(prefix: string, colors?: Colors) {
		this.prefix = prefix;
		this.colors = {
			log: colors?.log,
			debug: colors?.debug,
			info: colors?.info,
			error: colors?.error,
			warn: colors?.warn,
		};
	}
	log(...msg: any) {
		const color = this.colors.log || '#bf5af2';
		console.log(`%c${this.prefix}`, Logger.logStyle(color), ...msg);
	}
	info(...msg: any) {
		const color = this.colors.info || '#fed709';
		console.info(`%c${this.prefix}`, Logger.logStyle(color), ...msg);
	}

	debug(...msg: any) {
		const color = this.colors.debug || '#5e5ce6';
		console.debug(`%c${this.prefix}`, Logger.logStyle(color), ...msg);
	}

	warn(...msg: any) {
		const color = this.colors.warn || 'rgb(255,204,0)';
		console.warn(`%c${this.prefix}`, Logger.logStyle(color), ...msg);
	}

	error(...msg: any) {
		const color = this.colors.error || 'rgb(255, 45, 85)';
		console.error(`%c${this.prefix}`, Logger.logStyle(color), ...msg);
	}

	static logStyle(color: string) {
		return `color: white; background: ${color}; border-radius: 6px; padding: 2px 12px;`;
	}
}

interface Colors {
	log?: string;
	info?: string;
	debug?: string;
	error?: string;
	warn?: string;
}
